import ProcessActionRoutes from '../constants/process_action_routes';

import CompleteActivityResponseHandler from './activity_form/complete_activity_response_handler';
import CancelProcessResponseHandler from './activity_form/cancel_process_response_handler';

export default class ActivityFormResponseHandler {
	static execute(storeItem, response, request) {
		const requestURL = request.url;
		switch(requestURL) {
			case ProcessActionRoutes.CANCEL_PROCESS:
				CancelProcessResponseHandler.execute(storeItem, response, request);
				break;
			case ProcessActionRoutes.COMPLETE_ACTIVITY:
			default:
				CompleteActivityResponseHandler.execute(storeItem, response, request);
				break;
		}
	}
}
